<template lang="pug">
div
  .card
    .container-fluid
      .row
        .col-md-12
          .white-box
            h1.box-title.m-b-0 トップページ スライド一覧
            p.text-muted.m-b-30.font-13 SWAN Proサイトのトップページスライド一覧画面
            h3.box-title スライド一覧
            WorkList(apiname='top_slide',editPath='top_slide/edit')
            router-link(to='top_slide/edit')
              el-button.col-md-12(type='primary', icon='el-icon-edit') 新規登録
</template>

<script>
import WorkList from '@/views/components/swan/common/List'
export default {
  name: 'Top',
  data () {
    return {
    }
  },
  components: {
    WorkList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/top_slide/list.vue